import Vue from 'vue'

export default () => 
	Vue.$http.get('workplan/photo-reason/')
		.then(response => response.data)



// WEBPACK FOOTER //
// ./src/services/workPlan/fetchPhotoReasons.js